import { useState } from "react";
import { faceLogin } from "@privateid/cryptonets-web-sdk";
import { getStatusMessage } from "@privateid/cryptonets-web-sdk/dist/utils";
import { useSearchParams } from "react-router-dom";

let userNotEnrolled = 0;
let USER_NOT_ENROLLED_THRESHOLD = 15;
let reTries = 0
const useFaceLoginWithLivenessCheck = (
  setShowSuccess: any = () => {},
  onSetStatus?: (e: number) => void,
  retryTimes = 3,
  isInitialPredict = true,
  onPredictFail?: any,
  onRetryFail?: () => void,
) => {
  const [searchParams] = useSearchParams();
  const [faceLoginWithLivenessMessage, setPredictMessage] = useState("");
  const [loginGUID, setLoginGUID] = useState("");
  const [loginPUID, setLoginPUID] = useState("");
  const [faceLoginInputImageData, setFaceLoginInputImageData] =
    useState<any>(null);
  const [faceLoginData, setPredictData] = useState<any>(null);
  const [faceLoginResponseStatus, setFaceLoginResponseStatus] =
    useState<number>();
  let tries = 0;
  const burningMan = searchParams.get("burningMan");
  const faceLoginWithLiveness = async (skipAntispoof = false) => {
    // @ts-ignore
    const faceLoginResponse = await faceLogin({
      callback: callback,
      config: {
        skipAntispoof:
          searchParams.get("skipAntispoof") === null
            ? true
            : searchParams.get("skipAntispoof") === "true" || skipAntispoof,
        allowed_results: [10],
        ...(burningMan === "true"
          ? {
              input_image_format: "rgba",
              antispoof_face_margin: 2,
              angle_rotation_left_threshold: 8.0,
              angle_rotation_right_threshold: 8.0,
              threshold_user_right: 0.01,
              threshold_user_left: 0.99,
              threshold_high_vertical_predict: -0.2,
              threshold_down_vertical_predict: 0.2,
              threshold_profile_predict: 0.65,
              threshold_user_too_close: 0.8,
              threshold_user_too_far: 0.1,
              gray_scale_variance_threshold: 100.0,
              anti_spoofing_detect_document: false,
              anti_spoofing_threshold: 0.8,
              gray_scale_threshold: 14.0,
              threshold_user_up: 0.01,
              threshold_user_down: 0.99,
            }
          : {}),
      },
    });
    // @ts-ignore
    const { imageData, response } = faceLoginResponse || {};
    setFaceLoginInputImageData(imageData);
    if (response) {
      alert(response);
       window.location.reload();
    }
  };

  const callback = async (result: any) => {
    console.log(result,'result');

    // console.log("faceLogin callback hook result:", result);
    if (![0, 10].includes(result.face_validation_status)) {
      if(result.face_validation_status === 8) {
        setPredictMessage("Move face into the frame");
      } else {
        setPredictMessage(getStatusMessage(result.face_validation_status));
      }
      faceLoginWithLiveness();
      return;
    }
    // setFaceLoginInputImageData(result?.imageData)
    handleWasmResponse(result);
  };

  const handleWasmResponse = (returnValue: any) => {
    if (returnValue?.face_validation_status !== -100) {
      setFaceLoginResponseStatus(returnValue?.face_validation_status);
    }
    if (
      [0, 10].includes(returnValue.face_validation_status) &&
      returnValue?.guid &&
      returnValue?.puid
    ) {
      handleValidImage(returnValue);
    } else if (returnValue.face_validation_status === -7) {
      handleUserNotEnrolled(returnValue);
    } else {
      handleInvalidImage(returnValue);
    }
  };

  const handleUserNotEnrolled = (returnValue: any) => {
    const { message = "", validation_status } = returnValue || {};
    if (userNotEnrolled < USER_NOT_ENROLLED_THRESHOLD) {
      userNotEnrolled++;
      faceLoginWithLiveness();
      setPredictMessage("Processing");
    } else {
      setShowSuccess(returnValue);
      setPredictData({
        ...returnValue,
        retryComplete: userNotEnrolled >= USER_NOT_ENROLLED_THRESHOLD,
      });
      userNotEnrolled = 0;
      onPredictFail();
    }
  };
  const handleValidImage = (returnValue: any) => {
    setPredictMessage("Valid Image");
    setPredictData({
      ...returnValue,
      retryComplete: !isInitialPredict && tries === retryTimes,
    });
    setLoginGUID(returnValue.guid);
    setLoginPUID(returnValue.puid);
    setShowSuccess(returnValue);
  };

  const handleInvalidImage = (returnValue: any) => {
    if (tries !== retryTimes) {
      if (reTries === 5 && onRetryFail) {
        onRetryFail?.();
      }
      if (isInitialPredict) {
        tries += 1;
        reTries += 1;
      }
      faceLoginWithLiveness();
    } else {
      setShowSuccess(returnValue);
      setPredictData({
        ...returnValue,
        retryComplete: !isInitialPredict && tries === retryTimes,
      });
      tries = 0;
    }
  };
  const resetFaceLogin = (callFunc = true) => {
    setPredictData(undefined);
    setFaceLoginInputImageData(null);
    setPredictMessage("");
    if (callFunc) {
      faceLoginWithLiveness();
    }
  };

  return {
    faceLoginWithLiveness,
    faceLoginWithLivenessMessage,
    faceLoginInputImageData,
    faceLoginData,
    resetFaceLogin,
    faceLoginResponseStatus,
    loginGUID,
    loginPUID,
    tries
  };
};

export default useFaceLoginWithLivenessCheck;
